import { Select, theme } from 'antd'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { SelectOption } from '../../../types/generalTypes'
import { WorkspaceDocumentSetStatus } from '../../../constants/constants'

const { useToken } = theme

interface SelectDocumentSetStatusProps {
  defaultValue?: WorkspaceDocumentSetStatus
  value?: WorkspaceDocumentSetStatus
  onChange?: (value: WorkspaceDocumentSetStatus | undefined) => void
  style?: Object
  loading?: boolean
}

const SelectDocumentSetStatus = ({
  defaultValue,
  value,
  onChange,
  loading,
}: SelectDocumentSetStatusProps) => {
  const { token } = useToken()
  const [selectedValue, setSelectedValue] = useState<
    WorkspaceDocumentSetStatus | undefined
  >(defaultValue)

  const options: SelectOption[] = [
    {
      label: t('workspaceDetailsPage.selectDocumentSetStatus.all') || '',
      value: 'all',
    },
    {
      label: t('workspaceDetailsPage.selectDocumentSetStatus.opened') || '',
      value: 'opened',
    },
    {
      label: t('workspaceDetailsPage.selectDocumentSetStatus.closed') || '',
      value: 'closed',
    },
  ]

  useEffect(() => {
    if (value) {
      setSelectedValue(value)
    }
  }, [value])

  const handleChange = (value: WorkspaceDocumentSetStatus) => {
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <Select
      className="select-workspace-filter"
      style={{ minWidth: 143, color: token.colorPrimary }}
      onChange={handleChange}
      value={selectedValue}
      options={options}
      placeholder={t('workspaceDetailsPage.selectDocumentSetStatus.all')}
      loading={loading}
      variant="borderless"
    />
  )
}

export default SelectDocumentSetStatus
